import DOMPurify from 'dompurify'

function SimpleText(props) {
  const classNames = 'tw-bg-gray-light md:tw-mb-6 tw-p-4 -tw-mt-1 md:tw-p-5 md:tw-pb-4 md:tw-pt-8 tw-mb-5 md:tw-bg-gray-light tw-rounded-2 md:tw-rounded-xl [&_li]:tw-ml-4 [&_p]:tw-mb-4 [&_strong]:tw-inline-block '+props.classNames;

  return (
    <div className={classNames} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(props.text) }} />
  );
}

export default SimpleText;
